export default "__VITE_PUBLIC_ASSET__af05356f__"